var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sub-action-container" },
    [
      _setup.gridConfiguration
        ? _c(_setup.LfGridComponent, {
            attrs: {
              gridConfiguration: _setup.gridConfiguration,
              itemData: _setup.subActionList,
              toolbarOptions: _setup.toolbarOptions,
              commandClick: _setup.onCommandClick,
              allowPaging: true,
              contextMenuItems: _setup.contextMenuItems,
            },
            on: {
              rowClick: _setup.onRowClick,
              contextMenuClicked: _setup.onContextMenuClicked,
            },
          })
        : _vm._e(),
      _c(_setup.PromptDialog, {
        attrs: {
          width: _setup.modalWidth,
          title: _setup.modalTitle,
          isOpened: _setup.modalOpened,
          context: _setup.context,
          formSchema: _setup.subActionFormSchema,
          formFieldValues: _setup.subActionFormValues,
        },
        on: {
          "execute-action": _setup.onPromptDialogExecuteAction,
          changeFormField: _setup.onChangeFormField,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }